import { render, staticRenderFns } from "./BenefitCardListPanel.vue?vue&type=template&id=1cb8dc14&scoped=true&"
import script from "./BenefitCardListPanel.vue?vue&type=script&lang=js&"
export * from "./BenefitCardListPanel.vue?vue&type=script&lang=js&"
import style0 from "./BenefitCardListPanel.vue?vue&type=style&index=0&id=1cb8dc14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb8dc14",
  null
  
)

export default component.exports